<template>
  <div>
    <v-snackbar
      id="next-payment-success-snackbar"
      v-model="snackbar.show"
      color="success"
      :multi-line="true"
      :timeout="snackbar.timeout"
      class="text-xs-center"
    >
      {{ snackbar.message }}
    </v-snackbar>

    <!--     Your Next Payment Card     -->
    <v-card color="white" class="card-border text-xs-left">
      <v-system-bar height="45" window color="itoviGrayLight">
        <h2 class="card-header-text">Your Next Payment</h2>
        <v-spacer />
      </v-system-bar>

      <div v-if="!(referralProgram && nextPayment)" class="pa-4">
        <v-progress-linear :indeterminate="true" />
      </div>
      <div class="card-body" v-if="referralProgram && nextPayment">
        <!-- payment info              -->
        <div>
          <div v-if="nextPayment.date">{{ nextPayment.date }}</div>
          <div :class="`next-payment-price ${(planDetails && planDetails.pending_status ? 'strikethrough' : '')}`">${{ nextPayment.amount }}</div>
          <div class="sm-lbl">includes tax</div>

          <v-layout v-if="planDetails && planDetails.pending_status" align-center row wrap>
            <div>
              This plan is scheduled to be {{ planDetails.pending_status.action_code === 'cancel' ? 'cancelled' : (planDetails.pending_status.action_code === 'hold' ? 'placed on hold' : 'changed') }} on {{ planDetails.pending_status.run_date }}.
            </div>
          </v-layout>
          <v-divider class="mt-4" />
        </div>

        <!-- referral info             -->
        <div class="pt-3 txt-bold">
          You have {{ referralProgram.referral_count ? referralProgram.referral_count : 0 }} referral{{ referralProgram.referral_count === 1 ? '' : 's' }}
        </div>

        <template v-for="(item, index) in referralProgram.buckets">
          <!-- todo: show a checkbox or something next to the item if item.bucket_goal_earned is true               -->

          <v-layout :key="index" align-center row wrap fill-height class="pt-2">
            <v-flex v-if="item.hasOwnProperty('bucket_goal_earned')" fill-height xs2>
              <v-icon v-if="item.bucket_goal_earned === true" color="primary">check_box_outline</v-icon>
              <v-icon v-if="item.bucket_goal_earned === false " color="primary">check_box_outline_blank</v-icon>
            </v-flex>
            <v-flex fill-height :class="item.hasOwnProperty('bucket_goal_earned') ? 'xs10' : 'xs12'">
              <span>{{ item.title }}</span>
            </v-flex>
          </v-layout>
        </template>

        <div class="pt-3 txt-bold" v-if="referralProgram.user_id">
          Your Referral ID: {{ referralProgram.user_id }}
        </div>

        <div class="text-xs-center pt-4">
          <v-btn v-if="!isAppView" round outline color="primary" @click="shareReferral">
            Share referral link
          </v-btn>
        </div>
      </div>
    </v-card>
  </div>
</template>

<style lang="scss">
  .strikethrough {
    text-decoration: line-through;
    color: orange;
  }
</style>

<script>
  import api from "../../../services/api_endpoints";
  import store from '@/store'
  import subscribeToStore from "@/mixins/subscribeToStore";

  export default {
    components: {
    },
    data: ()=> ({
      snackbar: {
        show: false,
        timeout: 2500,
        message: "Link copied to clipboard"
      },
      nextPayment: store.state.nextPayment,
      referralProgram: store.state.referralProgram,
      planDetails: store.state.planDetails,
      isAppView: store.state.isAppView,
      user_id: "",
    }),
    props: {
      onLoaded: Function,
    },
    mixins: [subscribeToStore],
    created(){
      this.fetchNextPayment()
    },
    mounted() {
      this.subscribeToStore(['isAppView', 'nextPayment', 'planDetails', 'referralProgram']);
    },
    methods: {
      formatPrice(value) {
        let val = (value/1).toFixed(2);
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      isFunction(functionToCheck) {
        return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
      },
      async fetchNextPayment() {
        await api.getNextPayment();
        await api.getReferralProgram();
        if (this.isFunction(this.onLoaded)) this.onLoaded();
      },
      async shareReferral() {
        // get the textarea if it's already been injected
        let invisibleInput = document.getElementById("invisible-input");
        if (invisibleInput == null) {
          // create/inject a new text area if it hasn't been injected yet
          invisibleInput = document.createElement("textarea");
          // it seems like it has to be visible on the screen for the 'copy' command
          // to work, but we'll make it as small as possible while it is visible
          invisibleInput.setAttribute('style', 'height: 1px; width: 1px;');
          invisibleInput.setAttribute('id', 'invisible-input');
          let snackbarElement = document.getElementById("next-payment-success-snackbar");
          document.body.insertBefore(invisibleInput, snackbarElement)
        }
        // fill the textarea and select the text
        invisibleInput.innerHTML = store.state.user.referral_link;
        invisibleInput.focus();
        invisibleInput.select();
        // copy the selected text to the clipboard
        try {
          if (!(await document.execCommand('copy')))
            this.snackbar.message = 'An error occurred copying your referral link'
        } catch (e) {
          this.snackbar.message = `${e}`
        }
        this.snackbar.show = true;
        // delete the textarea
        document.body.removeChild(invisibleInput);

        /** this way is better, but doesn't work in the webview in the app */
        // try {
        //   await navigator.clipboard.writeText(store.state.user.referral_link)
        // } catch (e) {
        //   this.snackbar.message = `${e}`
        // }
        // this.snackbar.show = true

      },
    },
  }
</script>
